function Header() {
    return (
        <div>
        <div id="toolBar">
            <div className="main">
            <ul id="toolBarLinks">
                <li><a title="alert" rel="noopener" href="http://www.etsu.edu/advisories">Advisories</a></li>
                <li><a title="goldlink" rel="noopener" href="http://goldlink.etsu.edu" >Goldlink</a></li>
                <li><a title="e-mail" rel="noopener" href="http://webmail.etsu.edu/">eMail</a></li>
                <li><a title="d2l" rel="noopener" href="http://elearn.etsu.edu/">D2L</a> </li>
                <li><a title="safety on campus" rel="noopener" href="http://www.etsu.edu/safety/" >Safety</a> </li>
                <li><a title="a to z index" rel="noopener" href="https://www.etsu.edu/ehome/atoz/" >A-Z index</a></li>
            </ul>
            <div className="clear"></div>
            </div>
        </div>

        <div id="logo">
            <div className="main">
            <div id="headerLogo">
                <a href="http://www.etsu.edu/" title="East Tennessee State University">
                <img className="headerImage" alt="ETSU" width="298" height="72" />
                </a>
            </div>
            <div id="headerTitle">
                Voyager Index Lookup
            </div>
            <div className="clear"></div>
        </div>
        </div>
    </div>
    );
}

export default Header;